import { post } from 'services/api/base';

import { ProductsSearchPayload, ProductsSearchResponse } from './types-search-for-products';

export function search(params?: ProductsSearchPayload): Promise<ProductsSearchResponse> {
  return post('v5/pos/products', { json: params }).json();
}
